module.exports = __webpack_public_path__ + "static/img/resource2.478e2bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resource2.jpg
// module id = 5j8O
// module chunks = 1